module.exports = __webpack_public_path__ + "static/img/qcx-a3.04e9c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcx-a3.png
// module id = EJzg
// module chunks = 1